import { GROUP_TYPES } from 'consts/config';

import UserSessionDataHandler from './UserSessionsDataHandler';

class Authenticate {
  constructor() {
    this.isUserAuthenticated = false;
    this.hasAdminAccess = false;
    this.checkIfUserAuthenticated();
    this.checkIfAdmin();
  }

  checkIfUserAuthenticated = () => {
    const result = UserSessionDataHandler.getToken();
    if (result != null && result !== '') this.isUserAuthenticated = true;
    else this.isUserAuthenticated = false;
  };

  checkIfAdmin = () => {
    const result = UserSessionDataHandler.getUserDataObject();
    if (
      result &&
      (result.group.includes(GROUP_TYPES.admin) ||
        result.group.includes(GROUP_TYPES.org_admin))
    )
      this.hasAdminAccess = true;
    else this.hasAdminAccess = false;
  };

  authenticate = (token, userSettings, userData) => {
    UserSessionDataHandler.saveToken(token);
    UserSessionDataHandler.saveUserSettingsObject(userSettings);
    UserSessionDataHandler.saveUserDataObject(userData);
    this.isUserAuthenticated = true;
  };

  unauthenticate = () => {
    localStorage.clear();
    window.location.reload();
    this.isUserAuthenticated = false;
    this.hasAdminAccess = false;
  };

  isAdmin = () => {
    this.checkIfAdmin();
    return this.hasAdminAccess;
  };

  isAuthenticated = () => {
    this.checkIfUserAuthenticated();
    return this.isUserAuthenticated;
  };
}

export default Authenticate;
